import { writeFetch, getSession } from '../api';

const CHAT_TABLE  = 'family_chat_messages_1749300000';
const NOTIF_TABLE = 'notifications_1741164676';

// ── Persist a sent message to the DB ────────────────────────────────────────
export async function persistMessage({ nodeId, nodeName, text }) {
  const user = getSession();
  if (!user) return null;

  const msgId = `cm-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
  const now   = new Date().toISOString();

  try {
    await writeFetch(`create/${CHAT_TABLE}`, {
      method: 'POST',
      body: JSON.stringify({
        id:                msgId,
        owner_id:          user.id,
        recipient_node_id: nodeId,
        recipient_name:    nodeName,
        sender_label:      'me',
        message:           text,
        direction:         'sent',
        is_read:           1,
        created_at:        now,
      }),
    });

    // Log a chat notification so it surfaces in the Notification Center
    await writeFetch(`create/${NOTIF_TABLE}`, {
      method: 'POST',
      body: JSON.stringify({
        id:         `notif-chat-${msgId}`,
        user_id:    user.id,
        owner_id:   user.id,
        title:      `💬 Message sent to ${nodeName}`,
        message:    text.length > 80 ? text.slice(0, 80) + '…' : text,
        type:       'chat',
        is_read:    0,
        created_at: now,
      }),
    });

    return msgId;
  } catch {
    return null;
  }
}

// ── Load persisted chat history for a given node ────────────────────────────
export async function loadChatHistory(nodeId) {
  const user = getSession();
  if (!user) return [];

  try {
    const res  = await writeFetch(
      `read/${CHAT_TABLE}?owner_id=${user.id}&recipient_node_id=${nodeId}&sort=created_at&order=asc&limit=100`
    );
    const data = await res.json();
    if (data.status === 'success' && Array.isArray(data.data)) {
      return data.data.map(row => ({
        id:   row.id,
        from: row.sender_label === 'me' ? 'me' : 'them',
        text: row.message,
        time: formatRelative(row.created_at),
      }));
    }
  } catch { /* silent */ }
  return [];
}

function formatRelative(dateStr) {
  if (!dateStr) return 'Just now';
  const diff = Date.now() - new Date(dateStr).getTime();
  const m    = Math.floor(diff / 60000);
  if (m < 1)  return 'Just now';
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  return `${Math.floor(h / 24)}d ago`;
}